import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAutomations, createAutomationAsync, updateAutomationAsync, deleteAutomationAsync } from '../store/automationSlice';
import AutomationForm from '../components/AutomationForm';
import { MdAdd, MdEdit, MdDelete } from 'react-icons/md';
import { toast } from 'react-toastify';
import { getAutomationEngine } from '../api/automations';

export default function AutomationsPage() {
  const dispatch = useDispatch();
  const { items: automations } = useSelector((state) => state.automations);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [engine, setEngine] = useState(null);

  useEffect(() => { dispatch(fetchAutomations()); }, [dispatch]);
  useEffect(() => {
    let active = true;
    getAutomationEngine().then(({ data }) => { if (active) setEngine(data); })
      .catch(() => { if (active) setEngine({ message: 'Stato esecuzione non disponibile. Le regole salvate non garantiscono l’attivazione.' }); });
    return () => { active = false; };
  }, []);

  const engineNotice = (
    <p role="status" className="mb-4 rounded-md border border-warning/40 bg-warning-bg p-3 text-sm text-warning">
      {engine?.message || 'Verifica dello stato di esecuzione delle automazioni…'}
    </p>
  );

  const handleSave = async (data) => {
    try {
      if (editing) {
        await dispatch(updateAutomationAsync({ id: editing.id, data })).unwrap();
        toast.success('Automazione aggiornata');
      } else {
        await dispatch(createAutomationAsync(data)).unwrap();
        toast.success('Automazione creata');
      }
      setShowForm(false);
      setEditing(null);
    } catch {
      toast.error('Errore nel salvataggio');
    }
  };

  const handleToggle = (automation) => {
    dispatch(updateAutomationAsync({ id: automation.id, data: { is_active: !automation.is_active } }));
  };

  const handleDelete = async (id) => {
    await dispatch(deleteAutomationAsync(id));
    toast.info('Automazione eliminata');
  };

  if (showForm) {
    return (
      <div>
        <h2 className="text-xl font-semibold text-ink mb-6">
          {editing ? 'Modifica Automazione' : 'Nuova Automazione'}
        </h2>
        <AutomationForm initial={editing} onSave={handleSave} onCancel={() => { setShowForm(false); setEditing(null); }} />
        {engineNotice}
      </div>
    );
  }

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold text-ink">Automazioni</h2>
        <button onClick={() => setShowForm(true)}
          className="flex items-center gap-2 px-4 py-2 bg-brand-600 text-white text-sm font-medium rounded-md hover:bg-brand-700 transition-colors">
          <MdAdd size={18} /> Nuova Regola
        </button>
      </div>

      {engineNotice}
      {automations.length === 0 ? (
        <div className="bg-surface rounded-lg border border-line p-8 text-center">
          <p className="text-muted text-sm">Nessuna regola salvata. Puoi preparare le regole per il nuovo motore.</p>
        </div>
      ) : (
        <div className="grid gap-3">
          {automations.map((a) => (
            <div key={a.id} className="bg-surface rounded-lg border border-line p-4">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-ink">{a.name}</p>
                  <p className="text-xs text-muted mt-1">
                    {a.trigger_type}: <span className="font-mono">{a.trigger_value || 'tutti'}</span>
                    {' → '}{a.action_type}
                  </p>
                </div>
                <div className="flex items-center gap-3">
                  <button onClick={() => handleToggle(a)}
                    className={`w-10 h-5 rounded-full transition-colors relative ${a.is_active ? 'bg-brand-500' : 'bg-line'}`}>
                    <span className={`absolute top-0.5 w-4 h-4 bg-surface rounded-full shadow transition-transform ${a.is_active ? 'left-5' : 'left-0.5'}`} />
                  </button>
                  <button onClick={() => { setEditing(a); setShowForm(true); }}
                    className="text-muted hover:text-info"><MdEdit size={18} /></button>
                  <button onClick={() => handleDelete(a.id)}
                    className="text-muted hover:text-danger"><MdDelete size={18} /></button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
